// extracted by mini-css-extract-plugin
export default {"wrapper-container":"TextAlignInput_wrapper-container__mR69M","button-item":"TextAlignInput_button-item__1R7X5"};